import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {IonicStorageModule} from '@ionic/storage';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {SelectPackagePageModule} from './pages/package/select-package/select-package.module';
import {TokenInterceptor} from './interceptors/token.interceptor';
import {AuthGuardService} from './services/guard/auth-guard.service';
import {LoggedInAuthGuardService} from './services/guard/logged-in-auth-guard.service';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AngularFireModule} from '@angular/fire';
import {AngularFireMessagingModule} from '@angular/fire/messaging';
import {ShareModule} from './share/share.module';

@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            mode: 'md'
        }),
        IonicStorageModule.forRoot({
            name: '__mydb',
            driverOrder: ['indexeddb', 'sqlite', 'websql']
        }),
        AppRoutingModule,
        HttpClientModule,
        SelectPackagePageModule,
        AngularFireModule.initializeApp(environment.firebase),
        ServiceWorkerModule.register('combined-sw.js', {enabled: environment.production}),
        AngularFireMessagingModule,
        ShareModule
    ],
    providers: [
        StatusBar,
        SplashScreen,
        AuthGuardService,
        LoggedInAuthGuardService,
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
        // {provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

}
